import React from 'react';
import { useTranslation } from 'react-i18next';

const CategoryFilter = ({ categories, selectedCategory, onCategoryChange, collections, selectedCollection, onCollectionChange }) => {
  const { t } = useTranslation();
  
  // Ensure categories is an array
  const categoriesArray = Array.isArray(categories) ? categories : [];
  
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <div className="mb-6">
        <h3 className="text-bmb-text font-medium mb-4">{t('catalog.filters.categories')}</h3>
        <div className="space-y-2">
          {/* All Categories Option */}
          <label className="flex items-center cursor-pointer">
            <input
              type="radio"
              name="category"
              value=""
              checked={!selectedCategory || selectedCategory === ''}
              onChange={() => onCategoryChange('')}
              className="mr-2 text-bmb-text focus:ring-bmb-text"
            />
            <span className="text-sm text-gray-600 hover:text-bmb-text transition-colors font-medium">
              {t('categories.all')} ({categoriesArray.reduce((sum, cat) => sum + (cat.count || 0), 0)})
            </span>
          </label>
          
          {/* Individual Categories */}
          {categoriesArray.map((category) => (
            <label key={category.value} className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="category"
                value={category.value}
                checked={selectedCategory === category.value}
                onChange={(e) => onCategoryChange(e.target.value)}
                className="mr-2 text-bmb-text focus:ring-bmb-text"
              />
              <span className="text-sm text-gray-600 hover:text-bmb-text transition-colors">
                {category.label} ({category.count})
              </span>
            </label>
          ))}
        </div>
      </div>

      {collections && collections.length > 0 && (
        <div className="mb-6">
          <h3 className="text-bmb-text font-medium mb-4">{t('catalog.filters.collections')}</h3>
          <div className="space-y-2">
            <label className="flex items-center cursor-pointer">
              <input
                type="radio"
                name="collection"
                value=""
                checked={!selectedCollection}
                onChange={() => onCollectionChange('')}
                className="mr-2 text-bmb-text focus:ring-bmb-text"
              />
              <span className="text-sm text-gray-600 hover:text-bmb-text transition-colors">
                {t('catalog.filters.all_collections')}
              </span>
            </label>
            {collections.map((collection) => (
              <label key={collection} className="flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="collection"
                  value={collection}
                  checked={selectedCollection === collection}
                  onChange={(e) => onCollectionChange(e.target.value)}
                  className="mr-2 text-bmb-text focus:ring-bmb-text"
                />
                <span className="text-sm text-gray-600 hover:text-bmb-text transition-colors">
                  {collection}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}

      <button
        onClick={() => {
          onCategoryChange('');
          if (onCollectionChange) onCollectionChange('');
        }}
        className="w-full py-2 px-4 bg-bmb-accent text-bmb-text text-sm rounded hover:bg-gray-200 transition-colors"
      >
        {t('catalog.filters.clear_filters')}
      </button>
    </div>
  );
};

export default CategoryFilter;